import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import Grid from '@mui/material/GridLegacy';
import { motion } from 'framer-motion';

const AboutSection: React.FC = () => {
  return (
    <Box
      id="about"
      sx={{
        py: 10,
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        backdropFilter: 'blur(5px)',
        borderTop: '1px solid #1A1A1A',
      }}
    >
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <Typography
            variant="h2"
            align="center"
            sx={{
              mb: 6,
              fontSize: { xs: '2rem', md: '2.25rem' },
            }}
          >
            What is VECTOR?
          </Typography>
        </motion.div>

        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <Box
                sx={{
                  backgroundColor: '#0A0A0A',
                  border: '1px solid #1A1A1A',
                  borderRadius: 3,
                  p: 4,
                  height: '100%',
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontFamily: 'monospace',
                    color: '#1D9BF0',
                    mb: 2,
                  }}
                >
                  VECTOR \ˈvek-tər\ (noun, intel)
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontStyle: 'italic',
                    color: '#C7CDD3',
                  }}
                >
                  a directional pattern linking motive, capability, and access — 
                  the axis along which events unfold and decisions are made.
                </Typography>
              </Box>
            </motion.div>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <Typography variant="body1" sx={{ mb: 3 }}>
                VECTOR is a comprehensive intelligence data management platform designed 
                specifically for law enforcement and intelligence agencies. It provides 
                a secure, centralized system for gathering, analyzing, and sharing 
                critical intelligence data.
              </Typography>
              <Typography variant="body1">
                Built with CJIS v6.0 compliance at its core, VECTOR enables agencies 
                to streamline their intelligence operations while maintaining the highest 
                standards of data security and access control.
              </Typography>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default AboutSection;